export default {
  payWelfareText: 'Aufladevorteile',
  blackFridayDiscount: 'Black Friday Rabatt',
  shareGift: 'Geschenk teilen',
  vipWeeklyWelfare: 'VIP Wochen-Rabatt',
  exchangeCoupon: 'Coupon',
  firstPayOff: 'Bis zu 15% RABATT für 1. Kauf.',
  blackFridayEvent: 'Black Friday Event',
  limitedTimeOff: 'Für begrenzte Zeit 10% RABATT.',
  claimCoupon: 'Jetzt abholen',
  blackFridayTimedCoupon: 'Black Friday Coupon',
  timeLeft: 'Zeit übrig:',
  claimTimeCoupon: 'Hole jetzt den 10% RABATT-Coupon ab!',
  points: 'Punkte: ${point}',
  costPointTip: 'Tausche Punkte für Coupons.',
  maxPointTip: 'Jedes Konto kann bis zu 500 Pkt. verwenden.',
  discountOff: '10% RABATT',
  highestDiscount: 'Bis zu ${discount} RABATT',
  needPoint: 'Benötigt ${point} Pkt.',
  changeCurrency: 'Währung ändern',
  claim: 'Abholen',
  claimSucc: 'Abgeholt',
  claimFail: 'Fehlgeschlagen',
  pointNotEnough: 'Unzureichende Pkt.',
  afterClaimPoint: 'Punkte übrig: ${point}',
  footTips1: 'Für jede Bestellung kann nur 1 Coupon verwendet werden.',
  footTips2:
    'Der Coupon kann nicht für den Kauf von In-Game-Währungen/Tokens verwendet werden.',
  footTips3: 'Die endgültige Auslegung dieses Events behalten wir uns vor.',
  ruleTitleText: 'Eventregeln',
  ruleTime:
    'Eventdauer: 24. Nov. 2023, 00:00 Uhr bis 26. Nov. 2023, 23:59 Uhr (UTC)',
  bfRuleText1:
    '1. 400 Punkte werden deinem Konto gutgeschrieben, wenn du dich während des Events zum ersten Mal auf der offiziellen Aufladeseite anmeldest. Du kannst bis zu 500 Punkte gegen Coupons eintauschen.',
  bfRuleText2:
    '2. Du kannst während des Events Black Friday-Punkte gegen Coupons eintauschen.',
  bfRuleText3:
    '3. Du kannst pro Bestellung nur 1 Coupon einlösen. Coupons können nicht für den Kauf von In-Game-Währungen/Tokens verwendet werden.',
  bfRuleText4:
    '4. Für Transaktionen akzeptieren wir nur die folgenden Währungen:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Du darfst die Währung nicht ändern, nachdem eine Transaktion durchgeführt wurde. Umgetauschte Punkte können nicht erstattet werden.',
  bfRuleText6: '6. Black Friday-Coupons sind nur 7 Tage lang gültig.',
  bfRuleText7: '7. Die endgültige Auslegung dieses Events behalten wir uns vor.',
  thanksTip:
    'Danke für deine Teilnahme. Bitte trete unserer offiziellen Community bei, um weitere Event-Informationen zu erhalten.',
  exchangePoints: 'Austauschen',
  exchangeCode: 'Tauschcode eingeben.',
  enterExchangeCode: 'Bitte Tauschcode eingeben.',
  exchangeText: 'Austauschen',
  confirmGet: 'Bestätigen',
  couponUsedWay:
    'Der Coupon kann nur mit bestimmten Währungen verwendet werden. Bitte bestätige deine Währung.',
  confirmText: 'Bestätigen',
  exchangeSucc: 'Getauscht',
  aboutCoins: 'In-Game-Währungen/Token',
  aboutCoinsText:
    'Du kannst In-Game-Währungen/Token gegen alle Pakete und Privilegien eintauschen, mit Ausnahme der In-Game-Währung/Token selbst.',
  known: 'OK',
  codeText: 'Code',
  codeInvalid: 'Ungültiger Code!',
  hasExchanged: 'Du kannst keine weiteren Codes abholen.',
  hideText: 'Verbergen',
  //黑五的报错码
  'bf-20001': 'Nicht eingeloggt',
  'bf-20002': 'Parameterfehler. Bitte versuche erneut, am Event teilzunehmen.',
  'bf-20003': 'Unzureichende Pkt.',
  'bf-20004':
    'Fehlgeschlagen! Bitte versuche es später noch einmal oder wende dich an den Kundendienst.',
  'bf-20005': 'Abgeholt',
  'bf-20015': 'Das Event ist aktuell nicht verfügbar.',
  'bf-20016': 'Das Event ist aktuell nicht verfügbar.',
  bfShareText: 'Hole jetzt den 10% RABATT-Coupon ab!',
  rightsCenterBtn: 'Premium-Mitgliederzentrum',
  payBtn: 'AUFLADEN',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorreiche Ausnahme (Dauerhaft)',
  '-': '-'
};
